import { PageLayout } from "../components/PageLayout";
import { WideOpener, AtmoBreak } from "../components/ImageBlocks";
import { useLanguage } from "../contexts/LanguageContext";

const BASE = `${process.env.PUBLIC_URL}/bilder`;

export default function Editorial() {
  const { t } = useLanguage();
  return (
    <PageLayout>
      {/* Kapitelöffner — Block 3 Wide mit Seitentitel im Bild */}
      <WideOpener
        src="wide-3-0_haltung_21-9_v01.jpg"
        alt={t("menuEditorial")}
        heading={t("menuEditorial")}
      />

      <div
        className="mx-auto w-full max-w-3xl text-[17px] leading-[1.6] sm:text-[18px]"
        style={{ color: "#1A1A1A" }}
        data-testid="page-editorial-body"
      >
        {/* 2-Spalten Layout: Porträt links, Text rechts — Text fließt NIE unters Bild */}
        <div className="sm:flex sm:items-start sm:gap-8">
          <figure
            data-testid="editorial-portrait"
            className="mb-6 w-full sm:mb-0 sm:w-[280px] sm:shrink-0"
          >
            <div className="overflow-hidden rounded-sm" style={{ aspectRatio: "1/1" }}>
              <img
                src={`${BASE}/04_IST/Editorial_under5mb_v1.jpg`}
                alt="Stephan Weiler"
                loading="lazy"
                className="block h-full w-full select-none object-cover"
                draggable={false}
              />
            </div>
            <figcaption className="mt-3 text-sm" style={{ color: "rgba(26,26,26,0.75)" }}>
              <span className="block italic">Stephan Weiler</span>
              <span
                className="mt-0.5 block text-xs"
                style={{ color: "rgba(26,26,26,0.55)", letterSpacing: "0.3px" }}
              >
                Ein Socializer
              </span>
            </figcaption>
          </figure>

          <div className="flex-1 space-y-6">
            <p>{t("editorial_p1")}</p>
            <p>{t("editorial_p2")}</p>
            <p>{t("editorial_p3")}</p>
            <p>{t("editorial_p4")}</p>
            <p
              className="border-l-2 pl-5 italic"
              style={{ borderColor: "#2A2624", color: "#1A1A1A" }}
            >
              {t("editorial_quote")}
            </p>
          </div>
        </div>
      </div>

      {/* Abschluss-Atmo */}
      <AtmoBreak src="3-0_vision_16_v01.jpg" alt="" />
    </PageLayout>
  );
}
